import React from 'react';
import ModulePlaceholder from '../common/ModulePlaceholder';

export default function Notifications() {
  return (
    <ModulePlaceholder
      title="Notifications"
      icon="🔔"
      description="Review alerts for overdue invoices, unpaid bills, low inventory and system events."
      related={[
        { label: 'Invoices', path: '/invoices' },
        { label: 'Bills', path: '/bills' },
        { label: 'Inventory', path: '/inventory' },
      ]}
    />
  );
}
